import request from '@/utils/request'

/**
 * 获取 95OBD配置响应
 */
function getResponseList(data) {
    return request({
        url:'/nineFiveResponse/list',
        method:'post',
        data
    })
}

/**
 * 新增 95OBD配置响应
 */
function createResponse(data) {
    return request({
        url:'/nineFiveResponse',
        method:'post',
        data
    })
}

/**
 * 编辑 95OBD配置响应
 */
function updateResponse(id,data) {
    return request({
        url:`/nineFiveResponse/${id}`,
        method:'put',
        data
    })
}

/**
 * 删除 95OBD配置响应
 */
function deleteResponse(id) {
    return request({
        url:`/nineFiveResponse/${id}`,
        method:'delete',
        id
    })
}
export {
    getResponseList,
    createResponse,
    updateResponse,
    deleteResponse
}